<template>
    <div>
        <section class="content">
            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-default">
                        <div class="box-body table-responsive no-padding">
                            <el-table :data="tableData" stripe border style="width: 100%" v-loading.body="loading"
                                      class="cd-todoTable">
                                <el-table-column fixed type="selection" width="55" align="center"></el-table-column>
                                <el-table-column fixed prop="order_id_sn" label="ID" width="240" align="center"
                                                 v-if="!isHomePageSub"></el-table-column>
                                <el-table-column prop="product_type" label="业务种类" width="120"
                                                 v-if="isHomePageSub"></el-table-column>
                                <el-table-column prop="customer" label="客户姓名" width="100"
                                                 align="center"></el-table-column>
                                <el-table-column prop="product_name" label="产品" align="center"></el-table-column>
                                <el-table-column prop="product_name" label="扣款金额" align="center">
                                    <template slot-scope="scope" v-if='scope.row.postDebit'>
                                        <span>{{scope.row.postDebit.total_amount}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="depart_name" label="门店" align="right" v-if="!isHomePageSub">
                                </el-table-column>
                                <el-table-column prop="originator" label="申请人" align="right"></el-table-column>
                                <el-table-column prop="staff_name" label="业务员" align="right"></el-table-column>
                                <!-- <el-table-column prop="active_time" label="所属部门"></el-table-column>
                                <el-table-column prop="staff_name" label="当前执行人"></el-table-column>
                                <el-table-column prop="leader" label="团队长"></el-table-column> -->
                                <el-table-column prop="active_time" label="最后处理时间" align="center"></el-table-column>
                                <el-table-column fixed="right" label="操作" width="250">
                                    <template slot-scope="scope">
                                        <!-- {{scope.row.staff_id}} -->
                                        <el-button type="warning" size="small" v-if="0 == scope.row.staff_id"
                                                   @click="(e) => {return rowActionHandle(e, 'showChoice', scope.row)}">
                                            {{scope.row.node_name}}
                                        </el-button>
                                        <el-button type="success" size="small" v-else
                                                   @click="(e) => {return rowActionHandle(e, 'goto', scope.row)}">
                                            {{scope.row.node_name}}
                                        </el-button>
                                        <el-button type="warning" size="small"
                                                   v-if="2 == scope.row.last_transition_type"
                                                   @click="(e) => {return rowActionHandle(e, 'showMsg', scope.row)}">
                                            退回原因
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="box-footer clearfix">
                            <div class="row">
                                <div class="col-md-4 col-sm-6">
                                    <!--
                                    <el-button type="text" size="small" @click="(e) => {return pageActionHandle(e, 'selectAll')}">全选</el-button>
                                    <el-button type="text" size="small" @click="(e) => {return pageActionHandle(e, 'selectOther')}">反选</el-button>
                                    <el-button type="danger" icon="delete2" @click="(e) => {return pageActionHandle(e, 'batchDelete')}">批量删除</el-button>
                                    -->
                                </div>
                                <div class="col-md-8 col-sm-6 text-right">
                                    <el-pagination :current-page="currentPage"
                                                   @size-change="sizeChangeHandle" @current-change="pageChangeHandle"
                                                   :page-sizes="[20, 30, 50, 100]" :page-size="pageSize"
                                                   :total="totalRow"
                                                   layout="total, prev, pager, next, sizes, jumper">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <el-dialog :title="chargeMsgDialog.title" :visible.sync="chargeMsgDialog.visible" stripe>
            <el-table :data="chargeMsgDialog.data" border>
                <el-table-column property="title" label="扣款类型"></el-table-column>
                <el-table-column property="value" label="扣款金额"></el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog :title="backMsgDialog.title" :visible.sync="backMsgDialog.visible" size="tiny">
            <el-form ref="backMsgForm">
                <el-form-item label="退回原因" prop="last_msg" :error="error.last_msg">
                    <el-input type="textarea" v-model="backMsgDialog.last_msg" style="width:100%;" disabled>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="backMsgDialog.visible = false">关 闭</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="choiceDialog.title" :visible.sync="choiceDialog.visible" size="tiny">
            <el-form ref="choiceForm">
                <el-form-item label="分配给" prop="staff_id" :error="error.staff_id">
                    <el-select v-model="choiceDialog.staff_id" filterable placeholder="请选择" style="width:100%;"
                               required>
                        <el-option
                                v-for="item in staffChoiceList"
                                :key="item.staff_id"
                                :label="item.name"
                                :value="item.staff_id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="choiceDialog.visible = false">关 闭</el-button>
                <el-button type="primary" @click="(e) => {return pageActionHandle(e, 'choiceForm', choiceDialog)}">保 存
                </el-button>
            </div>
        </el-dialog>
        <popupWin :visible="showPopupWin" @closed="showPopupWin = false" :info="popupWinInfo"></popupWin>
    </div>
</template>
<style>
    .tableLink {
        color: #00F;
    }

    .tableLink:hover {

        text-decoration: underline;
    }
</style>
<script>
    import $ from 'jquery'
    import _this from '../../../lib/car/task/chargeOrder'
    import popupWin from '../order/popup'

    let _p = window.xwCommon, pageTitle = _this.title, name = _this.name,
        tableData = [],
        methods = {
            rowActionHandle(e, a, obj) {

                switch (a) {
                    case "goto":
                        switch (obj.open) {
                            case "popup":
                                this.popupWinInfo = obj
                                this.showPopupWin = true
                                break;
                            default:
                                let params = {node: obj.order_node_id, id: obj.order_id,}
                                this.$bus.emit('push-router', {name: "order_chargeFlow", params})
                                break;
                        }

                        break;
                    case "view":
                        let params = {id: obj.order_id, node: obj.order_node_id}
                        this.$bus.emit('push-router', {name: "car_view_page", params})
                        break;
                    case "showMsg":
                        this.backMsgDialog.last_msg = obj.last_msg
                        this.backMsgDialog.visible = true
                        break;
                    case "showChargeType":
                        this.chargeMsgDialog.visible = true;
                        this.chargeMsgDialog.data = obj.postDebit.post_item
                        break;
                    case "showChoice":
                        _this.showChoiceWin(this, obj.order_node_id)
                        break;
                    default:
                        console.log(arguments)
                        break;
                }
            },
            pageActionHandle(e, a, obj) {
                switch (a) {
                    case "choiceForm":
                        if (_p.isNull(obj.staff_id)) {
                            vm.$set(vm.error, "staff_id", "请选择一个用户")
                        } else {
                            _this.submitChoice(this, obj.order_node_id, obj.staff_id)
                        }

                        break;
                }
            },
            sizeChangeHandle(s) {
                //console.log(arguments)
                //this.currentPage
                _this.readList(this, null, s)
            },
            pageChangeHandle(p) {
                //console.log(arguments)
                _this.readList(this, p)
            },
            setClassName(row, column, rowIndex, columnIndex) {
                console.log(row, column, rowIndex, columnIndex)
            },
            red(differ) {
                let time = differ.split("小时");
                if (time.length > 1) return false
                else {
                    time = differ.split("分钟");
                    if (Number(time[0]) > 30) return false
                    else return true
                }
            },
        }

    export default {
        name, methods,
        components: {popupWin},
        props: ['isHomePageSub'],//主页显示待办任务隐藏一些列表
        data: () => {
            return {
                pageTitle, tableData, loading: true, staffChoiceList: [],
                showPopupWin: false, popupWinInfo: {},
                currentPage: 1, totalRow: 0, pageSize: 20, error: {},
                backMsgDialog: {"title": "退回原因", "ref": "backForm", "visible": false},
                choiceDialog: {"title": "分配任务", "ref": "choiceForm", "visible": false, "staff_id": null},
                chargeMsgDialog: {"title": '扣款列表', "visible": false, "data": []}
            }
        },
        mounted() {
            // 设置标题
            _p.setTitle(pageTitle)
            _this.readList(this)
            this.$bus.on('reloadTodo', () => {
                _this.readList(this)
            })
        }
    }
</script>


// WEBPACK FOOTER //
// chargeOrder.vue?69ab5a1f